<template>
  <div class="headerMenu">
    <div v-if="selectedMeeting" class="header">
        <v-tabs show-arrows="mobile" class="header" height="38" background-color="transparent">
            <v-tab
              small
              class="white--text"
              active-class="white--text primary"
              @click="setSelectedBookie(null), selectedAll()">
              All <strong>${{numeral(allBetsTotalMeeting()).format('0.0a')}}</strong>
            </v-tab>
          <v-tab v-for="item in bookiesrace" :key="item.bookie"
          class="white--text"
          active-class="white--text bookieSelected"
          @click="setSelectedBookie(item.bookie), selectedBookmaker()">
            <img :src="`https://betmakers.com/img/circle_logos/${item.bookie}.png`" width="28px" style="padding-right: 5px">
            <strong>${{numeral(item.total).format('0.0a')}}</strong>
          </v-tab>
        </v-tabs>
    </div>
    <div v-else>
      <div style="display: inline-block">
        <v-btn style="margin-right: 5px"
          x-large
          active-class="bookieSelected"
          @click="setSelectedBookie(null), selectedAll()">
          <div>All <strong>${{numeral(allBetsTotalMeeting()).format('0.0a')}}</strong></div>
        </v-btn>
      </div>
      <div v-for="item in items" :key="item.bookie" style="display: inline-block;">
        <v-btn style="margin-right: 5px;"
          x-large
          @click="setSelectedBookie(item.bookie), selectedBookmaker()">
          <img :src="`https://betmakers.com/img/circle_logos/${item.bookie}.png`" width="45px" style="padding-right: 5px">
            <strong>${{numeral(item.total).format('0.0a')}}</strong>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import numeral from 'numeral'

export default {
  name: 'HeaderMenu',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    bookiesrace: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      numeral,
      bookie_button: 0
    }
  },
  methods: {
    ...mapActions(['clearSelections', 'setSelectedBookie', 'fetchRunners', 'fetchRaces', 'fetchBets', 'fetchBetsByType', 'fetchBookieBets', 'fetchBookieBetsDated']),
    ...mapState(['selectedRace', 'selectedMeeting']),
    allBetsTotal () {
      return this.items.reduce((acc, curr) => acc + curr.total, 0)
    },
    allBetsTotalMeeting () {
      return this.bookiesrace.reduce((acc, curr) => acc + curr.total, 0)
    },
    selectedAll () {
      // this.bookie_button = [0];
      this.fetchBets({ pagination: { page: 1, limit: 5 }, filtered: true })
      this.fetchRaces()
      this.fetchRunners()
      this.fetchBetsByType()
      this.fetchBookieBets()
      this.fetchBookieBetsDated()
    },
    selectedBookmaker () {
      this.fetchBets({ pagination: { page: 1, limit: 5 }, filtered: true })
      this.fetchRaces()
      this.fetchRunners()
      this.fetchBetsByType()
      this.fetchBookieBets()
      this.fetchBookieBetsDated()
    }
  }
}
</script>

<style scoped>
.bookieSelected {
  background: rgb(233, 10, 124) !important;
  color: white;
}
.headerMenu {
  display: flex;
}
.bookieHeaderTabs {
  max-height:40px;
}
</style>
